import React, { useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";

const MenuField = ({
  label,
  options,
  placeholder,
  selectedOption,
  onOptionSelect,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleOptionClick = (option) => {
    onOptionSelect(option.label); // Pasa la opción seleccionada
    console.log("Opción seleccionada:", option.label); // Verificar
    setIsMenuOpen(false); // Cierra el menú
  };

  return (
    <div className="mb-4 relative">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="relative">
        {/* Campo de entrada */}
        <div
          onClick={toggleMenu}
          className="w-full py-2 pl-3 pr-10 text-sm text-gray-900 border rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
        >
          {selectedOption
            ? selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1)
            : placeholder}
        </div>

        {/* Menú desplegable */}
        {isMenuOpen && (
          <ul className="absolute z-10 w-full bg-white border rounded-lg shadow-lg mt-1">
            {options.map((option) => (
              <li
                key={option.label}
                className="flex justify-between items-center px-3 py-1 hover:bg-gray-100 cursor-pointer text-sm"
                onClick={() => handleOptionClick(option)}
              >
                <span>{option.label}</span>
                <div
                  className="relative group flex items-center justify-center rounded-full"
                  style={{
                    backgroundColor: "#fff",
                    width: "20px",
                    height: "20px",
                  }}
                >
                  <FaQuestionCircle className="text-violet-800" size={12} />
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block bg-black text-white text-xs rounded py-1 px-2">
                    {option.tooltip}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MenuField;
